'use client';

import { Alert, Button, CircularProgress, Typography } from "@mui/material";
import { useState } from "react";
import StorylineServerProxy from "../storyline-proxy/storyline-proxy";

function formatSize(bytes: number): string {
    if(bytes < 1024){
        return `${bytes} bytes`;
    }
    if(bytes < 1024 * 1024){
        return `${(bytes / 1024).toFixed(1)} KB`;
    }
    return `${(bytes / (1024 * 1024)).toFixed(1)} MB`;
}

export default function DatabaseBackup(){
    const [isRunning, setIsRunning] = useState(false);
    const [message, setMessage] = useState("");
    const [error, setError] = useState("");

    async function runBackup(destination: "download" | "local"){
        setIsRunning(true);
        setMessage("");
        setError("");

        try{
            const result = destination == "download"
                ? await StorylineServerProxy.downloadDatabaseBackup()
                : await StorylineServerProxy.storeDatabaseBackup();

            if(!result?.fileName){
                throw new Error(result?.message || "Database backup failed");
            }

            if(destination == "download"){
                setMessage(`Downloaded ${result.fileName} (${formatSize(result.size)}).`);
            }
            else{
                setMessage(`Stored ${result.fileName} on the server (${formatSize(result.size)}).`);
            }
        }
        catch(error){
            setError(error instanceof Error ? error.message : "Database backup failed");
        }
        finally{
            setIsRunning(false);
        }
    }

    return (
        <>
            <Typography variant="h5" sx={{ marginBottom: 1 }}>Database backup</Typography>
            <Typography sx={{ marginBottom: 2 }}>
                Create a compressed backup of the currently selected storyline database. Files and application configuration are not included.
            </Typography>
            <Button disabled={isRunning} onClick={() => runBackup("download")} sx={{ marginRight: 1 }}>
                Download backup
            </Button>
            <Button disabled={isRunning} onClick={() => runBackup("local")}>
                Store on server
            </Button>
            {isRunning ? <><br/><CircularProgress sx={{ marginTop: 2 }}/><Typography>Creating database backup…</Typography></> : <></>}
            {message ? <Alert severity="success" sx={{ marginTop: 2 }}>{message}</Alert> : <></>}
            {error ? <Alert severity="error" sx={{ marginTop: 2 }}>{error}</Alert> : <></>}
        </>
    );
}
